//@flow
import {
  select,
  call,
  put,
  takeLatest,
  takeEvery,
  fork,
  all,
} from "redux-saga/effects";

import {
  GLOSSARY_GET_REQUESTING,
  GLOSSARY_GET_SUCCESS,
  GLOSSARY_GET_ERROR,
  GLOSSARY_DELETE_WORD_REQUESTING,
  GLOSSARY_MODIFY_DEFINITION_REQUESTING,
  GLOSSARY_MODIFY_DEFINITION_SUCCESS,
  GLOSSARY_MODIFY_DEFINITION_ERROR,
  GLOSSARY_DELETE_WORD_SUCCESS,
  GLOSSARY_DELETE_WORD_ERROR,
} from "./constants";

import { fetchApi } from "../api";
import { AlertType, showAlert } from "../profileSettings/actions";
import i18n from "../../i18n";

const endPoints = {
  modifyDefinition: "/v1/glossary/definition",
  deleteWord: "/v1/glossary/word",
  getGlossary: "/v1/glossary/", // clientId
};

const getGlossaryApi = payload => {
  return fetchApi(`${endPoints.getGlossary}${payload}`, {}, "get");
};

const modifyDefinitionApi = payload => {
  return fetchApi(`${endPoints.modifyDefinition}`, payload, "patch");
};

const deleteWordApi = payload => {
  return fetchApi(`${endPoints.deleteWord}`, payload, "delete");
};

function* getGlossaryFlow(action) {
  try {
    const success = yield call(getGlossaryApi, action.payload);
    yield put({ type: GLOSSARY_GET_SUCCESS, payload: success });
  } catch (error) {
    console.log(error);
    yield put({ type: GLOSSARY_GET_ERROR, payload: error });
  }
}

function* modifyDefinitionFlow(action) {
  try {
    const success = yield call(modifyDefinitionApi, action.payload);
    yield put({ type: GLOSSARY_MODIFY_DEFINITION_SUCCESS, payload: success });
    yield put(
      showAlert({
        title: i18n.t("glossary-modify-success-title"),
        message: "",
      }),
    );
  } catch (error) {
    console.log(error);
    yield put({ type: GLOSSARY_MODIFY_DEFINITION_ERROR, payload: error });
  }
}

function* deleteWordFlow(action) {
  try {
    const success = yield call(deleteWordApi, action.payload);
    yield put({ type: GLOSSARY_DELETE_WORD_SUCCESS, payload: success });
    yield put(
      showAlert({
        title: i18n.t("glossary-delete-success-title"),
        alertType: AlertType.WARNING,
      }),
    );
  } catch (error) {
    console.log(error);
    yield put({ type: GLOSSARY_DELETE_WORD_ERROR, payload: error });
  }
}

function* notificationsWatcher() {
  yield all([
    takeLatest(GLOSSARY_GET_REQUESTING, getGlossaryFlow),
    takeLatest(GLOSSARY_MODIFY_DEFINITION_REQUESTING, modifyDefinitionFlow),
    takeLatest(GLOSSARY_DELETE_WORD_REQUESTING, deleteWordFlow),
  ]);
}

export default notificationsWatcher;
